import { render, staticRenderFns } from "./FinancePayoutsRecipient.vue?vue&type=template&id=5a445bdc&"
import script from "./FinancePayoutsRecipient.vue?vue&type=script&lang=js&"
export * from "./FinancePayoutsRecipient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports